import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EditStudentService } from '../edit-student.service';
import { MessageService } from '../../../core/services/message.service';
import { LoginUserService } from '../../../core/services/login-user.service';
@Component({
  selector: 'app-bind-modal',
  templateUrl: './bind-modal.component.html',
  styleUrls: ['./bind-modal.component.scss']
})
export class BindModalComponent implements OnInit {


  @Input() display: boolean = false;
  @Input() activeData: any = {};
  @Output() isDisplay: any = new EventEmitter();
  @Output() isBindSuccess: any = new EventEmitter();
  public timeCode: number = 0;//timefly
  public sId: string = null;//验证信息id
  public code: string = null;//验证码
  constructor(
    private _eidtStuService: EditStudentService,
    private _msg: MessageService,
    private _login: LoginUserService
  ) { }
  ngOnInit() {
  }
  // 关闭模态框
  targetDialog() {
    this.timeCode = 0;
    this.isDisplay.emit(this.display);
  }
  getRegCode() {
    if (this.activeData.value) {
      if (this.timeCode === 0) {
        this.timeCode = 60;
        this.getTimeCode();
        this._eidtStuService.postUserBingCode(this.activeData.value).then(resp => {
          if (resp.success) {
            if (resp['data']['type']) {
              this.sId = resp['data']['sId'];
            } else {
              this._msg.warn(resp['data']['message']);
              this.timeCode = 0;
            }
          } else {
            this.timeCode = 0;
            this._msg.warn(resp['message']);
          }
        })
      }
    } else {
      this._msg.warn(this.activeData.name + "不能为空");
    }
    setTimeout(() => { this._msg.clear(); }, 3000);
  }
  //验证倒计时
  getTimeCode() {
    if (this.timeCode > 0) {
      this.timeCode--;
      setTimeout(() => { this.getTimeCode() }, 1000)
    } else {
      this.timeCode = 0;
    }
  }
  //绑定数据
  bindData() {
    if (!this.activeData.isbind) { //this.activeData.isbind  为 false 是绑定
      if (!this.activeData.value) {
        this._msg.warn(this.activeData.name + "不能为空");
        setTimeout(() => { this._msg.clear(); }, 3000);
      } else if (!this.code) {
        this._msg.warn("验证码不能为空");
        setTimeout(() => { this._msg.clear(); }, 3000);
      } else {
        //发请求绑定数据
        let obj = { code: this.code, sId: this.sId, account: this.activeData.value };
        this._eidtStuService.postUserBindData(obj).then(resp => {
          if (resp.success) {
            if (resp['data']['type']) {
              this._msg.success(resp['data']['message']);
              this.isBindSuccess.emit("true");
            } else {
              this._msg.warn(resp['data']['message']);
            }
          } else {
            this._msg.warn(resp['message']);
          }
          this.targetDialog();
          setTimeout(() => { this._msg.clear(); }, 3000);
        })
      }
    } else { //this.activeData.isbind  为 true 是解除绑定  getUserRelieveBind
      if (!this.activeData.value) {
        this._msg.warn(this.activeData.name + "不能为空");
        setTimeout(() => { this._msg.clear(); }, 3000);
      } else {
        let id = this._login.getLoginInfo()['student_id'];
        let type;
        switch (this.activeData.type) {
          case 'phone':
            type = 4
            break;
          case 'email':
            type = 5
            break;
          case 'weixin':
            type = 1
            break;
          case 'QQ':
            type = 2
            break;
          case 'weibo':
            type = 3
            break;
        }
        this._eidtStuService.getUserRelieveBind(id, type).then(resp => {
          if (resp.success) {
            if (resp['data']['type']) {
              this._msg.success(resp['data']['message']);
              this.isBindSuccess.emit("true");
            } else {
              this._msg.warn(resp['data']['message']);
            }
          } else {
            this._msg.warn(resp['message']);
          }
          this.targetDialog();
          setTimeout(() => { this._msg.clear(); }, 3000);
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/bind-modal/bind-modal.component.ts